/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedRepositoryResourcesCard" />
import * as React from "react";

import * as Resources from "Build/ArtifactsView/Resources";
import { ConsumedArtifactDetails } from "Build/Client/Contracts/DataProvider";
import { ISourceProviderService } from 'Build/SourceProviders/SourceProvider';
import { ConsumedArtifactTypes, ConsumedArtifactPropertyKeys, IConsumedArtifactsCardProps } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsResources"
import { ConsumedArtifactSource } from "Build/Client/Contracts/DataProvider";

import * as StringUtil from "VSS/Core/Util/String";
import { ObservableArray } from "VSS/Core/Observable";
import { ICancelReason } from "VSS/Core/Util/Promise";
import { Table, ITableColumn, TableColumnStyle, SimpleTableCell } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { Icon } from "VSSUI/Icon";
import { onClickFPS } from "VSS/Platform/FPS";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { getAssetLocation } from "VSS/Platform/Location";

interface IConsumedRepositoryResourcesCardState {
    commitLink: string;
}

export class ConsumedRepositoryResourcesCard extends VssComponent<IConsumedArtifactsCardProps, IConsumedRepositoryResourcesCardState> {

    constructor(props: IConsumedArtifactsCardProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            commitLink: '#'
        }
    }

    public componentDidMount() {
        super.componentDidMount();
        if (this.props.consumedSource) {
            const sourceProviderService = this.context.pageContext.getService<ISourceProviderService>("ISourceProviderService");
            const sourceProvider = sourceProviderService.getSourceProvider(this.props.consumedSource.artifactType);
            const repositoryName = (this.props.consumedSource.consumedArtifacts && this.props.consumedSource.consumedArtifacts.length > 0)
                                        ? this.props.consumedSource.consumedArtifacts[0].artifactName : '';
            const commitId = this.props.consumedSource.versionId ? this.props.consumedSource.versionId.split(':')[0] : '';
            const projectId = this.props.consumedSource.properties[ConsumedArtifactPropertyKeys.ProjectId];

            if (sourceProvider) {
                    this.trackPromise(
                        sourceProvider.fetchCommitLink({
                            repositoryName: repositoryName,
                            commitId: commitId,
                            displayUri: ""
                        }, projectId)
                    ).promise
                .then((link: string) => {
                    this.setState({
                        commitLink: link
                    });
                }, (error: ICancelReason) => {
                    if (!error.isCanceled) {
                        console.log(error);
                    }
                });
            }
        }
    }

    public render(): JSX.Element {
        if (!this.props.consumedSource)
        {
            return <React.Fragment/>;
        }

        const commitId = this.props.consumedSource.versionId ? this.props.consumedSource.versionId.split(':')[0] : '';

        return (
            <Card
                className="bolt-table-card"
                headerIconProps={{render: this._renderIcon }}
                titleProps={{ text: this.props.consumedSource.alias + ' / ' + commitId }}
                headerCommandBarItems={this._commandBarItems}
                contentProps={{ contentPadding: false }}>
                {this._jobsTable()}
            </Card>
        );
    }

    private _renderIcon = (): JSX.Element => {
        return (
            <div>
                <img
                    src={getAssetLocation(this.context.pageContext, "ms.vss-build-web/artifacts-view/icons/repository.svg")}
                    alt={Resources.Repository} />
            </div>
        );
    }

    private _jobsTable(): JSX.Element {
        const itemProvider = new ObservableArray(this.props.consumedSource.consumedArtifacts);
        return <Table itemProvider={itemProvider} columns={this._jobsTableColumns} ariaLabel={Resources.ConsumedRepositoryTableText} />
    }

    private _getIcon = (artifact: ConsumedArtifactSource): string => {
        if (artifact)
        {
            if (StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.TfsVersionControl, true)) {
                return "TFVCLogo";
            }
            if (StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.TfsGit, true)) {
                return "GitLogo";
            }
            if (StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.GitHub, true) ||
                StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.GitHubEnterprise, true)) {
                return "GitHubLogo";
            }
            if (StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.Svn, true)) {
                return "SVNLogo";
            }
            if (StringUtil.equals(artifact.artifactType, ConsumedArtifactTypes.Bitbucket, true)) {
                return "BitbucketLogo32";
            }
        }

        // Generic
        return "Repo";
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ConsumedArtifactDetails>, tableItem: ConsumedArtifactDetails): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex} contentClassName="fontSizeM scroll-hidden">
                <Icon className="pipelines-icon-right-margin" iconName={this._getIcon(this.props.consumedSource)} />
                <div className="flex-row scroll-hidden">
                    <Tooltip overflowOnly={true} text={tableItem.artifactName}>
                        <span className="text-ellipsis fontWeightSemiBold">{tableItem.artifactName}</span>
                    </Tooltip>
                </div>
            </SimpleTableCell>
        );
    }

    private readonly _commandBarItems: IHeaderCommandBarItem[] = [
        {
            important: true,
            id: "viewDetails" + this.props.consumedSource.versionId,
            text: Resources.ViewDetails,
            onActivate: () => {
                onClickFPS(this.context.pageContext, this.state.commitLink, true);
            }
        }
    ];

    private readonly _jobsTableColumns: ITableColumn<ConsumedArtifactDetails>[] = [
        {
            id: Resources.ConsumedArtifactsNameColumn,
            width: -100,
            name: Resources.ConsumedArtifactsNameColumn,
            renderCell: this._renderNameCell,
            columnStyle: TableColumnStyle.Primary
        }
    ];
}